import React from "react";
import {ApolloClient, InMemoryCache, ApolloProvider, HttpLink} from "@apollo/client";
import {useAppBridge, Redirect} from "@shopify/app-bridge-react";
import {authenticatedFetch} from "@shopify/app-bridge-utils";

function userLoggedInFetch(app) {
  const fetchFunction = authenticatedFetch(app);

  return async (uri, options) => {
    const response = await fetchFunction(uri, options);

    if (response.headers.get("X-Shopify-API-Request-Failure-Reauthorize") === "1") {
      const reauthzURL = response.headers.get("X-Shopify-API-Request-Failure-Reauthorize-Url");

      const redirect = Redirect.create(app);
      redirect.dispatch(Redirect.Action.APP, reauthzURL ?? "/auth");
      return null;
    }

    return response;
  };
}

const GraphQLProvider = ({children}) => {
  const app = useAppBridge();

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: new HttpLink({
      credentials: "include",
      fetch: userLoggedInFetch(app),
    }),
  });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default GraphQLProvider;
